import React, { useEffect } from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Form, Input, RequiredHelpPhrase, Row, SonForm, SubmitButton, TextParam, useForm } from '../../../_lib/Form2';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';

export type AttributeGroupPageLeadEditForm = { form: SonForm<TextParam<'title'>> };

export function AttributeGroupPageLeadEditForm({ form }: AttributeGroupPageLeadEditForm) {
  const { t } = useSonTranslation('AttributeGroups');
  const { formProps, fetchState, params } = useForm({ form, activateLeavingGuard: true });
  const { delayedRefresh } = useRefreshBlock();

  useEffect(() => {
    if (fetchState.type === 'success') {
      delayedRefresh();
    }
  }, [delayedRefresh, fetchState.type]);

  return (
    <Form id="attribute-group-page-lead-form" {...formProps}>
      <RequiredHelpPhrase />
      <Row>
        <Input label={t('pagelead.form.title')} param={params.getByName('title')} />
      </Row>
      <SubmitButton
        buttonLabel={t('pagelead.form.button')}
        messageSuccess={t('pagelead.form.status.success')}
        messageSending={t('pagelead.form.status.sending')}
        messageFail={t('pagelead.form.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}
